/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'shared/store/store'
import {
  fetchRecipientsBuildingTypesRequest,
  fetchRecipientsClientAddressesRequest,
  fetchRecipientsCommitteesRequest,
} from 'shared/store/sendMessage/recipients'
import {
  getMessageRecipients,
  getRecipientsCommittees,
} from 'shared/store/sendMessage/recipients/selectors'
import { FilterTypeEnum } from '../models/Recipients'

const useInitRecipientsFilters = () => {
  const dispatch = useAppDispatch()
  const { filters } = useAppSelector(getMessageRecipients)

  const { data: committees } = useAppSelector(getRecipientsCommittees)

  useEffect(() => {
    dispatch(fetchRecipientsClientAddressesRequest())
    dispatch(fetchRecipientsBuildingTypesRequest())
  }, [])

  useEffect(() => {
    if (
      filters.filterType === FilterTypeEnum.BoardMembers &&
      !committees?.length
    ) {
      dispatch(fetchRecipientsCommitteesRequest())
    }
  }, [dispatch, filters.filterType, filters.boardId])
}

export default useInitRecipientsFilters
